// extracted by mini-css-extract-plugin
export var button = "AddToCartButton-module--button--1fEdF";
export var added = "AddToCartButton-module--added--3ltEF";
export var text = "AddToCartButton-module--text--2W1CN";
export var show = "AddToCartButton-module--show--2Pkm3";